import { TASKS_CODES } from '../../constants';
import { TasksState, TasksActions, TasksActionTypes } from './types';

const initialState: TasksState = {
  items: [],
  loading: false,
  loaded: false,
  error: '',
};

const tasksReducer = (state = initialState, action: TasksActions) => {
  switch (action.type) {
    case TasksActionTypes.GET_TASKS:
      return {
        ...state,
        loading: true,
        loaded: false,
      };
    case TasksActionTypes.GET_TASKS_ERROR:
      return {
        ...state,
        loading: false,
        loaded: false,
        error: action.error,
      };
    case TasksActionTypes.GET_TASKS_SUCCESS:
    case TasksActionTypes.SET_TASKS_SUCCESS:
      return {
        ...state,
        loading: false,
        loaded: true,
        items: action.payload,
      };
    case TasksActionTypes.MARK_DONE_TASK: {
      const updatedTask = action.payload;
      const updatedItems = state.items.map(task => {
        if (task.fields.taskCode === updatedTask.fields.taskCode) {
          return {
            ...task,
            ...updatedTask,
          };
        }

        return task;
      });

      return {
        ...state,
        items: [...updatedItems],
      };
    }
    case TasksActionTypes.MARK_UNDONE_TASK: {
      const updatedTask = action.payload;
      const updatedItems = state.items.map(task => {
        if (task.fields.taskCode === updatedTask.fields.taskCode) {
          return {
            ...task,
            ...updatedTask,
          };
        }

        return task;
      });

      return {
        ...state,
        items: [...updatedItems],
      };
    }
    case TasksActionTypes.TRACK_COPY_LINK_TASK: {
      const updatedItems = state.items.map(task => {
        if (task.fields.taskCode === TASKS_CODES.LINK_LANDING) {
          return {
            ...task,
            fields: {
              ...task.fields,
              done: true,
            },
          };
        }

        return task;
      });

      return {
        ...state,
        items: [...updatedItems],
      };
    }
    default:
      return state;
  }
};

export default tasksReducer;
